import * as http from './http';
import urls, {
    apiHost,
    apiPrefix,
    siteHost,
    fileHost,
} from './urls';
urls.apiHost = apiHost;
urls.fileHost = fileHost;
urls.siteHost = siteHost;
urls.apiPrefix = apiPrefix;

import * as api from './api/index.js';

export { fileWithHost } from './fileWithHost';

export { urls, http, api };

export { fetchApi, fetchAllApi, getAPI, callAPI } from './fetchApi';
